import type { Router } from 'vue-router'
import router from '@/router'
import { useAppContext } from '@/stores/appContext'
import { isString } from '@vue/shared'
const queryLanguageKey='language';
export const useLanguageCode=(router:Router)=>{
  router.beforeEach((to, from, next) => {
    const appContext=useAppContext();
     let languageCode= to.query[queryLanguageKey];
     if(languageCode&&isString(languageCode)){
       languageCode=languageCode.toLowerCase();
       appContext.locale=languageCode as string;
     }
     return next();
  })
}